import { socialApiClient } from '@/shared/api-client/social-api-client';
import { convertPostsRequestBody, type PostsParams } from './index';

export async function getExportPostKey(params: PostsParams) {
  const { queryId } = params;
  const requestBody = convertPostsRequestBody(params);

  const response = await socialApiClient
    .post(`queries/${queryId}/posts/export/register`, {
      json: requestBody,
    })
    .json<{
      key: string;
    }>();

  return response;
}

export function downloadExportedPosts(key: string) {
  const url = new URL(`${import.meta.env.VITE_SOCIAL_API_BASE_URL}/posts/export`);
  const a = document.createElement('a');

  url.searchParams.set('key', key);

  a.href = url.toString();
  a.download = '';
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
}
